import {
  CloudOutlined,
  FavoriteBorder,
  Public,
  PersonOutlined,
  PhoneIphone,
  EmailOutlined,
  LinkedIn,
  WhatsApp,
  GitHub,
} from "@mui/icons-material";
import algobite from "../data/images/algobite.webp";
import poke from "../data/images/pokedex.jpg";
import rick from "../data/images/rick.jpg";
import calatea from "../data/images/calatea.jpg";
import telocompro from "../data/images/telocompro.webp";

export const navlink = [
  {
    url: "/",
    text: "Home",
  },
  {
    url: "/skills",
    text: "Skills",
  },
  {
    url: "/portfolio",
    text: "Portfolio",
  },
  {
    url: "/contact",
    text: "Contact",
  },
];
export const home = [
  {
    text: "HELLO I'M",
    name: "JUAN MANUEL BLANCO",
    post: "FULL STACK DEVELOPER",
  },
];
export const about = [
  {
    desc: "I worked as a biomedical technician for two years before beginning self-taught web development in the middle of 2021, followed by an extensive full-stack development course at the Academlo bootcamp, and finally, in July 2022, I did an intensive Full-Stack Development Bootcamp at Henry. Since then, my enthusiasm for this discipline has grown, and I have decided to pursue a career in the IT industry. I'm looking forward to all of the challenges that await me.",

    cover: "./images/man.png",
  },
];
export const services = [
  {
    id: 1,
    image:
      "https://upload.wikimedia.org/wikipedia/commons/6/6a/JavaScript-logo.png",
    alt: "Javascript",
  },
  {
    id: 2,
    image:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4c/Typescript_logo_2020.svg/1200px-Typescript_logo_2020.svg.png",
    alt: "Typescript",
  },
  {
    id: 3,
    image: "https://cdn-icons-png.flaticon.com/512/174/174854.png",
    alt: "HTML",
  },
  {
    id: 4,
    image: "https://cdn-icons-png.flaticon.com/512/732/732190.png",
    alt: "CSS",
  },
  {
    id: 5,
    image: "https://www.svgrepo.com/show/354259/react.svg",
    alt: "React",
  },
  {
    id: 6,
    image:
      "https://www.rlogical.com/wp-content/uploads/2023/03/Rlogical-Blog-Images-thumbnail.webp",
    alt: "Next.js",
  },
  {
    id: 7,
    image: "https://v4.material-ui.com/static/logo.png",
    alt: "MaterialUI",
  },
  {
    id: 8,
    image: "https://www.svgrepo.com/show/354274/redux.svg",
    alt: "redux",
  },
  {
    id: 9,
    image:
      "https://cdn.icon-icons.com/icons2/2699/PNG/512/atlassian_jira_logo_icon_170511.png",
    alt: "JIRA",
  },
  {
    id: 10,
    image: "https://cdn-icons-png.flaticon.com/512/6125/6125001.png",
    alt: "bitbucket",
  },
  {
    id: 11,
    image:
      "https://play-lh.googleusercontent.com/mzJpTCsTW_FuR6YqOPaLHrSEVCSJuXzCljdxnCKhVZMcu6EESZBQTCHxMh8slVtnKqo",
    alt: "slack",
  },
  {
    id: 12,
    image:
      "https://hopetutors.com/wp-content/uploads/2017/03/nodejs-logo-1.png",
    alt: "node.js",
  },
  {
    id: 13,
    image:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/2/29/Postgresql_elephant.svg/1200px-Postgresql_elephant.svg.png",
    alt: "postgres",
  },
  {
    id: 14,
    image: "https://icon.icepanel.io/Technology/svg/Jest.svg",
    alt: "Jest",
  },
  {
    id:15,
    image:'https://seeklogo.com/images/P/playwright-logo-22FA8B9E63-seeklogo.com.png',
    alt:'playwright'
  }
];
export const project = [
  {
    id: 1,
    icon: <CloudOutlined />,
    num: "89",
    title: "HAPPY CLIENTS",
  },
  {
    id: 2,
    icon: <FavoriteBorder />,
    num: "231",
    title: "PROJECTS COMPLEATED",
  },
  {
    id: 3,
    icon: <Public />,
    num: "108",
    title: "FILES DOWNLOADED",
  },
  {
    id: 4,
    icon: <PersonOutlined />,
    num: "1446",
    title: "LIENS OF CODE",
  },
];
export const portfolio = [
  {
    id: 11,
    cover: telocompro,
    name: "Marketplace E-commerce",
    category: "ecommerce",
    title: "Telocompro marketplace",
    show: "https://marketplace.com.bo",
  },
  {
    id: 1,
    cover: calatea,
    name: "Full Stack E-commerce",
    category: "ecommerce",
    title: "Calathea Market",
    url: "https://github.com/jmbvdev/Proyecto-Final",
    show: "https://api-plants-b6153.web.app/",
  },
  {
    id: 2,
    cover: algobite,
    name: "Full Stack Restaurant",
    category: "restaurant",
    title: "Algobite",
    url: "https://github.com/jmbvdev/algobite",
    show: "https://algobite.vercel.app/",
  },
  {
    id: 4,
    cover: poke,
    name: "Pokemon wiki",
    category: "wiki",
    title: "Pokedex",
    url: "https://github.com/jmbvdev/pokemon",
    show: "https://mellifluous-kleicha-e1690a.netlify.app",
  },
  {
    id: 5,
    cover: rick,
    name: "Rick and Morty wiki",
    category: "wiki",
    title: "Rick and Morty Api",
    url: "https://github.com/jmbvdev/Rick-and-Morty-API-2022",
    show: "https://stoic-bardeen-97ddd1.netlify.app",
  },
];
export const testimonials = [
  {
    id: 1,
    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam porttitordapibus dictum.Fusce faucibus ligula scelerisque, eleifend turpis in",
    image: "./images/puppypedia.png",
    name: "Alamin Musa",
    post: "Front End Developer",
  },
  {
    id: 2,
    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam porttitordapibus dictum.Fusce faucibus ligula scelerisque, eleifend turpis in",
    image: "./images/testimonials/team-2.png",
    name: "Alex Ander",
    post: "Back End Developer",
  },
  {
    id: 3,
    text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam porttitordapibus dictum.Fusce faucibus ligula scelerisque, eleifend turpis in",
    image: "./images/testimonials/team-3.png",
    name: "GorkCoder",
    post: "React Developer",
  },
];
export const blog = [
  {
    id: 1,
    title: "Master These Awesome",
    date: "Jun 27, 2022",
    author: "Dorian Gray",
    desc: "Lorem Ipsum has been standard. Lorem Ipsum is simply text of the printing and typesetting industry. Lorem Ipsum has been",
    cover: "./images/blog/b1.png",
  },
  {
    id: 2,
    title: "Best Design Items to Appeal",
    date: "Jun 27, 2022",
    author: "Dorian Gray",
    desc: "Lorem Ipsum has been standard. Lorem Ipsum is simply text of the printing and typesetting industry. Lorem Ipsum has been",
    cover: "./images/blog/b2.png",
  },
  {
    id: 3,
    title: "The 20 Best Lightroom Presets",
    date: "Jun 27, 2022",
    author: "Dorian Gray",
    desc: "Lorem Ipsum has been standard. Lorem Ipsum is simply text of the printing and typesetting industry. Lorem Ipsum has been",
    cover: "./images/blog/b3.png",
  },
];
export const contact = [
  {
    icon: <PhoneIphone />,
    text1: "+34 608318046",
  },
  {
    icon: <EmailOutlined />,
    text1: "jmbv.dev@gmail.com",
  },
  {
    icon: <GitHub />,
    text1: "jmbvdev",
  },
];
export const social = [
  {
    icon: <GitHub />,
    url: "https://github.com/jmbvdev",
  },
  {
    icon: <LinkedIn />,
    url: "https://www.linkedin.com/in/jmbv-dev",
  },
  {
    icon: <WhatsApp />,
    url: "https://wa.link/x05vy4",
  },
];
